import { COMPANY_SIZE, type CompanySize } from 'src/data/company';
import { getUserCompanySize, getUserCountry, type User } from 'src/data/user';

const URL = 'https://calendar.app.google/Go9mdNwstjUFEsmK8';

const ALLOWED_COUNTRIES = [
  'United States',
  'U.S. Virgin Islands',
  'Canada',
  'United Kingdom',
  'Israel',
  'Singapore',
  'Hong Kong',
  'Switzerland',
  'Sweden',
  'Norway',
  'New Zealand',
  'Australia',
  'Netherlands',
  'Luxembourg',
  'Ireland',
  'Germany',
  'France',
  'Finland',
  'Denmark',
  'Belgium',
  'Austria',
  'Spain',
  'Italy',
];

const DISALLOWED_COMPANY_SIZES: CompanySize[] = [
  COMPANY_SIZE.size_1,
  COMPANY_SIZE.size_2_10,
  COMPANY_SIZE.size_11_50,
];

/**
 * Check if the user is allowed to book a demo based on their company size and country.
 * @param user - The user to check.
 * @returns true if the user is allowed to book a demo, false otherwise.
 */
export const isUserAllowedToBookDemo = (user: User): boolean => {
  const companySize = getUserCompanySize(user);
  if (!companySize || DISALLOWED_COMPANY_SIZES.includes(companySize)) {
    return false;
  }

  const country = getUserCountry(user);
  if (country) {
    return ALLOWED_COUNTRIES.includes(country);
  }
  return true;
};

/**
 * Get "book demo" URL.
 * HINT: Keeping it as a function, cause we might want to return some logic in the future, but for now it just returns a constant URL.
 */
export const getBookDemoUrl = (): string => {
  return URL;
};
